<h1 mat-dialog-title class="mbp-confirm-dialog__title">{{ data.title }}</h1>
<div mat-dialog-content class="mbp-confirm-dialog__content medicine-dosage-dialog">
  <mat-tab-group (selectedIndexChange)="mainTabIndex = $event">
    <mat-tab label="Create">
      <p class="medicine-dosage-dialog__intro">{{ data.message }}</p>
      <form autocomplete="off" [formGroup]="medicineDosageTypeForm">
        <div class="row">
          <p class="col-md-6">
            <core-dosage-type-search-field
              [control]="medicineDosageTypeForm.controls['dosageType']"
              [dosageUnits]="dosageUnits"
              (dosageTypeCreated)="onDosageTypeCreated($event)">
            </core-dosage-type-search-field>
          </p>

          <p class="col-md-6">
            <mat-form-field appearance="outline">
              <mat-label>Display name</mat-label>
              <input required type="text" formControlName="additionalInformation" matInput>
              @if (medicineDosageTypeForm.get('additionalInformation')?.invalid) {
                <mat-error>
                  Display name is invalid
                </mat-error>
              }
            </mat-form-field>
          </p>

          <p class="col-md-6">
            <mat-form-field appearance="outline">
              <mat-label>Strength</mat-label>
              <input required formControlName="dosageStrength" type="text" matInput>
              @if (medicineDosageTypeForm.get('dosageStrength')?.invalid) {
                <mat-error>
                  Strength is invalid
                </mat-error>
              }
            </mat-form-field>
          </p>

          <p class="col-md-6">
            <mat-form-field appearance="outline">
              <mat-label>Active</mat-label>
              <mat-select formControlName="isActive">
                <mat-option [value]="true">Yes</mat-option>
                <mat-option [value]="false">No</mat-option>
              </mat-select>
              @if (medicineDosageTypeForm.get('isActive')?.invalid) {
                <mat-error>
                  Active is invalid
                </mat-error>
              }
            </mat-form-field>
          </p>
        </div>

        <p>
          <mat-form-field appearance="outline">
            <mat-label>Usage instructions</mat-label>
            <textarea required formControlName="usageInstructions" matInput></textarea>
            @if (medicineDosageTypeForm.get('usageInstructions')?.invalid) {
              <mat-error>
                Usage instructions is invalid
              </mat-error>
            }
          </mat-form-field>
        </p>

        <p>
          <mat-form-field appearance="outline">
            <mat-label>Storage directions</mat-label>
            <textarea required formControlName="storageDirections" matInput></textarea>
            @if (medicineDosageTypeForm.get('storageDirections')?.invalid) {
              <mat-error>
                Storage directions is invalid
              </mat-error>
            }
          </mat-form-field>
        </p>

        <p>
          <mat-form-field appearance="outline">
            <mat-label>Special instructions</mat-label>
            <textarea required formControlName="specialInstructions" matInput></textarea>
            @if (medicineDosageTypeForm.get('specialInstructions')?.invalid) {
              <mat-error>
                Special instructions is invalid
              </mat-error>
            }
          </mat-form-field>
        </p>

        <div class="medicine-dosage-dialog__form-actions">
          <button type="button" [disabled]="!medicineDosageTypeForm.valid" mat-flat-button color="primary"
          class="medicine-dosage-dialog__form-actions-btn" (click)="createMedicineDosageType()">Create</button>
        </div>
      </form>

      <mat-divider></mat-divider>
      <div class="medicine-dosage-dialog__section">
        <h3 class="medicine-dosage-dialog__section-title">Package types</h3>

        <mat-tab-group (selectedIndexChange)="packageTypesTabIndex = $event">
          <mat-tab label="Create package type">
            <form class="mt-2" [formGroup]="medicineDosagePackageTypeForm">
              <div class="row">

                <p class="col-md-6">
                  <mat-form-field appearance="outline">
                    <mat-label>Label name</mat-label>
                    <input required formControlName="labelName" type="text" matInput>
                    @if (medicineDosagePackageTypeForm.get('labelName')?.invalid) {
                      <mat-error>
                        Label name is invalid {{labelNameExceeds25Chars ? ": Max 25 characters allowed" : ""}}
                      </mat-error>
                    }
                    <mat-hint>Maximum of 25 characters</mat-hint>
                  </mat-form-field>
                </p>

                <p class="col-md-6">
                  <mat-form-field appearance="outline">
                    <mat-label>Price</mat-label>
                    <input required formControlName="price" type="number" matInput>
                    @if (medicineDosagePackageTypeForm.get('price')?.invalid) {
                      <mat-error>
                        Price is invalid
                      </mat-error>
                    }
                  </mat-form-field>
                </p>

                <p class="col-md-6">
                  <core-package-type-search-field
                    [control]="medicineDosagePackageTypeForm.controls['packageType']"
                    (packageTypeCreated)="onPackageTypeCreated($event)">
                  </core-package-type-search-field>
                </p>

                <p class="col-md-6">
                  <mat-form-field appearance="outline">
                    <mat-label>Quantity</mat-label>
                    <input required formControlName="containedQuantity" type="number"
                      matInput>
                      <span matSuffix>{{currentDosageUnit ? currentDosageUnit.unit : "-"}}</span>
                      @if (medicineDosagePackageTypeForm.get('containedQuantity')?.invalid) {
                        <mat-error>
                          Quantity is invalid
                        </mat-error>
                      }
                    </mat-form-field>
                  </p>

                  <p class="col-md-6">
                    <mat-form-field appearance="outline">
                      <mat-label>Units per pack</mat-label>
                      <input required formControlName="unitsPerPack" type="number" min="1" step="1" matInput>
                      <mat-hint>e.g. 1 for a 5ml bottle, 5 for a 5 × 1ml pack</mat-hint>
                      @if (medicineDosagePackageTypeForm.get('unitsPerPack')?.invalid) {
                        <mat-error>
                          Units per pack must be 1 or more
                        </mat-error>
                      }
                    </mat-form-field>
                  </p>

                  <p class="col-md-6">
                    <mat-form-field appearance="outline">
                      <mat-label>Minimum order qty</mat-label>
                      <input formControlName="minOrderQty" type="number" min="1" step="1" matInput>
                      <mat-hint>Leave empty if there is no minimum</mat-hint>
                    </mat-form-field>
                  </p>

                  <p class="col-md-6">
                    <core-sage-item-code-field></core-sage-item-code-field>
                  </p>

                </div>
              </form>
              <div class="my-2">
                <button mat-stroked-button [disabled]="!medicineDosagePackageTypeForm.valid"
                  (click)="createMedicineDosagePackageType()">
                  <mat-icon>add</mat-icon> Add package type
                </button>
              </div>
              <!--List out the package types :)-->
              @if (medicineDosageType) {
                <core-medicine-dosage-package-type-list [dosageUnit]="currentDosageUnit" (onUpdated)="onDosagePackageTypesUpdated($event)"
                  [medicineDosageTypeId]="medicineDosageType.id" [packageTypes]="packageTypes"
                  [medicineId]="data.medicineId" [medicineDosagePackageTypes]="medicineDosagePackageTypes">
                </core-medicine-dosage-package-type-list>
              }
            </mat-tab>
            <mat-tab label="Manage packages">
              <div class="medicine-dosage-dialog__manage-list">
                @for (type of packageTypes; track type) {
                  <div class="medicine-dosage-dialog__manage-row">
                    <span>{{ type.type }}</span>
                    <button type="button" (click)="deletePackageType(type)" mat-stroked-button class="medicine-dosage-dialog__manage-delete">Delete</button>
                  </div>
                }
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </mat-tab>
      <mat-tab label="Manage dosages">
        <core-dosage-type-manage-list
          [dosageUnits]="dosageUnits"
          (dosageTypesChange)="onDosageTypesManaged($event)">
        </core-dosage-type-manage-list>
      </mat-tab>
    </mat-tab-group>
  </div>
  @if (isManageView) {
    <div mat-dialog-actions align="end" class="mbp-confirm-dialog__actions">
      <button type="button" mat-stroked-button (click)="closeDialog()">Close</button>
    </div>
  } @else {
    <div mat-dialog-actions align="end" class="mbp-confirm-dialog__actions">
      <button type="button" mat-stroked-button [mat-dialog-close]="false">Cancel</button>
      <button type="button" [disabled]="!medicineDosageType" mat-flat-button color="primary" (click)="closeDialog()">
        <mat-icon>done</mat-icon> Done
      </button>
    </div>
  }
